var path = '/modules/contacts/views/pages/details/checkins.tpl.html';
var html = "<contact-checkins ng-if=\"vm.contact\" contact=\"vm.contact\"></contact-checkins>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/contacts/views/pages/details/checkins.tpl.html
// module id = 2073
// module chunks = 1